<template>
<!--  <el-container id="app">-->
<!--    <el-header v-show="isLogin">-->
<!--      <header-menu></header-menu>-->
<!--    </el-header>-->
<!--    <router-view/>-->
<!--  </el-container>-->
  <BaseApp :is-login="isLogin"></BaseApp>
<!--  <el-container id="app">-->
<!--    <el-aside width="70" v-if="isLogin">-->
<!--      <left-menu v-if="$store.state.menu.length"></left-menu>-->
<!--    </el-aside>-->
<!--    <el-container>-->
<!--      <el-header v-show="isLogin">-->
<!--        <left-header-menu></left-header-menu>-->
<!--      </el-header>-->
<!--      <router-view/>-->
<!--    </el-container>-->
<!--  </el-container>-->
</template>

<script>
import HeaderMenu from "./components/header/HeaderMenu";
import {GetUserInfo} from "./api/user";
import {GetBaseInfo} from "./api";
import LeftMenu from "./components/header/LeftMenu";
import LeftHeaderMenu from "./components/header/LeftHeaderMenu";
import BaseApp from "./components/V4/BaseApp";
export default {
  name: 'App',
  components: {BaseApp, LeftHeaderMenu, LeftMenu, HeaderMenu},
  data(){
    return {
      isLogin:false,
    }
  },
  mounted() {
    const user_login = this._get_login()
    if (user_login.code===200){
      GetUserInfo({user_id:user_login.data.user_id,token:user_login.data.token}).then(resp => {
        if (resp.code===200){
          this.isLogin = true
          this.$store.commit('setUserInfo',resp.data)
          // TODO
          var watermark_txt = 'GameBrain 素材系统 ' + resp.data.name
          // var watermark_txt = 'GameBrain自动化素材系统'
          this.watermark({ watermark_txt: watermark_txt })
        }
      })
    }
    // const base_info_status = this.$store.state.base_info_status
    // if (base_info_status===false){
    //   GetBaseInfo({}).then(resp => {
    //     if (resp.code===200){
    //       this.$store.commit('setBaseInfoStatus', true)
    //       this.$store.commit('setSourceHost', resp.data.sourceHost)
    //       this.$store.commit('setProductList', resp.data.productList)
    //       this.$store.commit('setCountryList', resp.data.countryList)
    //       this.$store.commit('setLanguageList', resp.data.languageList)
    //       this.$store.commit('setPushChannelList', resp.data.pushChannelList)
    //       this.$store.commit('setMaterialTypeList', resp.data.materialTypeList)
    //       this.$store.commit('setMaterialSizeList', resp.data.materialSizeList)
    //     }
    //   })
    // }
  },
  methods:{
    watermark(settings) {
      // 默认设置
      var defaultSettings = {
        watermark_txt: 'text',
        watermark_x: 20, // 水印起始位置x轴坐标
        watermark_y: 20, // 水印起始位置Y轴坐标
        watermark_rows: 20, // 水印行数
        watermark_cols: 20, // 水印列数
        watermark_x_space: 100, // 水印x轴间隔
        watermark_y_space: 50, // 水印y轴间隔
        watermark_color: '#aaa', // 水印字体颜色
        watermark_alpha: 0.15, // 水印透明度
        watermark_fontsize: '15px', // 水印字体大小
        watermark_font: '微软雅黑', // 水印字体
        watermark_width: 210, // 水印宽度
        watermark_height: 80, // 水印长度
        watermark_angle: 15// 水印倾斜度数
      }
      // 采用配置项替换默认值，作用类似jquery.extend
      if (arguments.length === 1 && typeof arguments[0] === 'object') {
        var src = arguments[0] || {}
        for (var key in src) {
          if (src[key] && defaultSettings[key] && src[key] === defaultSettings[key]) { continue } else if (src[key]) { defaultSettings[key] = src[key] }
        }
      }

      var oTemp = document.createDocumentFragment()

      // 获取页面最大宽度
      var page_width = Math.max(document.body.scrollWidth, document.body.clientWidth)
      var cutWidth = page_width * 0.0150
      var page_width = page_width - cutWidth
      // 获取页面最大高度
      // console.log(document.body.scrollHeight)
      var page_height = Math.max(document.body.scrollHeight, document.body.clientHeight)-60
      // var page_height = document.body.scrollHeight+document.body.scrollTop;
      // 如果将水印列数设置为0，或水印列数设置过大，超过页面最大宽度，则重新计算水印列数和水印x轴间隔
      if (defaultSettings.watermark_cols == 0 || (parseInt(defaultSettings.watermark_x + defaultSettings.watermark_width * defaultSettings.watermark_cols + defaultSettings.watermark_x_space * (defaultSettings.watermark_cols - 1)) > page_width)) {
        defaultSettings.watermark_cols = parseInt((page_width - defaultSettings.watermark_x + defaultSettings.watermark_x_space) / (defaultSettings.watermark_width + defaultSettings.watermark_x_space))
        defaultSettings.watermark_x_space = parseInt((page_width - defaultSettings.watermark_x - defaultSettings.watermark_width * defaultSettings.watermark_cols) / (defaultSettings.watermark_cols - 1))
      }
      // 如果将水印行数设置为0，或水印行数设置过大，超过页面最大长度，则重新计算水印行数和水印y轴间隔
      if (defaultSettings.watermark_rows == 0 || (parseInt(defaultSettings.watermark_y + defaultSettings.watermark_height * defaultSettings.watermark_rows + defaultSettings.watermark_y_space * (defaultSettings.watermark_rows - 1)) > page_height)) {
        defaultSettings.watermark_rows = parseInt((defaultSettings.watermark_y_space + page_height - defaultSettings.watermark_y) / (defaultSettings.watermark_height + defaultSettings.watermark_y_space))
        defaultSettings.watermark_y_space = parseInt(((page_height - defaultSettings.watermark_y) - defaultSettings.watermark_height * defaultSettings.watermark_rows) / (defaultSettings.watermark_rows - 1))
      }
      var x
      var y
      for (var i = 0; i < defaultSettings.watermark_rows; i++) {
        y = defaultSettings.watermark_y + (defaultSettings.watermark_y_space + defaultSettings.watermark_height) * i
        for (var j = 0; j < defaultSettings.watermark_cols; j++) {
          x = defaultSettings.watermark_x + (defaultSettings.watermark_width + defaultSettings.watermark_x_space) * j

          var mask_div = document.createElement('div')
          mask_div.id = 'mask_div' + i + j
          mask_div.className = 'mask_div'
          mask_div.appendChild(document.createTextNode(defaultSettings.watermark_txt))
          // 设置水印div倾斜显示
          mask_div.style.webkitTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)'
          mask_div.style.MozTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)'
          mask_div.style.msTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)'
          mask_div.style.OTransform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)'
          mask_div.style.transform = 'rotate(-' + defaultSettings.watermark_angle + 'deg)'
          mask_div.style.visibility = ''
          mask_div.style.position = 'absolute'
          mask_div.style.left = x + 'px'
          mask_div.style.top = y + 'px'
          mask_div.style.overflow = 'hidden'
          mask_div.style.zIndex = '9999'
          mask_div.style.pointerEvents = 'none'// pointer-events:none  让水印不遮挡页面的点击事件
          // mask_div.style.border="solid #eee 1px";
          mask_div.style.opacity = defaultSettings.watermark_alpha
          mask_div.style.fontSize = defaultSettings.watermark_fontsize
          mask_div.style.fontFamily = defaultSettings.watermark_font
          mask_div.style.color = defaultSettings.watermark_color
          mask_div.style.textAlign = 'center'
          mask_div.style.width = defaultSettings.watermark_width + 'px'
          mask_div.style.height = defaultSettings.watermark_height + 'px'
          mask_div.style.display = 'block'
          oTemp.appendChild(mask_div)
        }
      }
      document.body.appendChild(oTemp)
    },
  }
}
</script>

<style>
  html{
    height: 100%;
  }
  body{
    height: 100%;
    margin: 0;
    font-size: 14px !important;
  }
  #app{
    height: 100%;
    /*min-width: 1200px;*/
    background: #F2F6FC;
  }
  .custom_gray{
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
  }
  #app .el-header{
    height: 70px !important;
    background: #ffffff;
    /*background: #0a1e39;*/
  }
  #app .el-main{
    width: 100%;
    /*width: 1200px;*/
    margin: 0 auto;
    padding: 10px;
    position: relative;
    overflow: hidden;
    text-align: center
  }
  .my_content{
    width: 100%;
    height:calc(100vh - 125px) !important;
    overflow: auto;
    overflow-x: hidden;
    text-align: center
  }
  #app .el-footer{
    width: 100%;
    height: 60px;
    position: absolute;
    display: flex;
    align-items: center;
    z-index: 1;
    left: 0;
    bottom: 0;
    background: #ffffff;
  }
  a{
    text-decoration: none;
  }
  body::-webkit-scrollbar
   {
     width: 0 !important
   }
  .my-tools-one{
    padding: 15px;
    margin-bottom: 15px;
    box-shadow: 0 0 5px #ddd;
    border-radius: 6px 6px 0 0;
    padding-bottom: 0;
    background: #fff;
  }
  .my-tools-one ul{
    margin: 0px;
    padding: 0px;
    list-style-type:none;
  }
  .my-tools-one ul li{
    padding: 10px;
    border-bottom: 1px solid #F2F6FC;
    overflow: auto;
  }
  .my-tools-one ul li a {
    font-size: 14px;
    color: #606266;
    cursor: pointer;
    line-height: 30px;
  }
  .my-tools-one ul li a:hover{
    color: #409eff;
  }
  .my-tools-one-con .active{
    color: #409eff;
  }
  .my-tools-one-lab{
    width: 70px;
    float: left;
  }
  .my-tools-one-con{
    width: 80%;
    float: left;
    text-align: left;
  }
  .my-tools-one-more{
    width: 60px;
    float: right;
  }
  .my-tools-one-con-item{
    margin-right: 15px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .bg-primary{
    background: #0a1e39 !important;
  }
  .bg-success{
    background: #67C23A !important;
  }
  .bg-warning{
    background: #E6A23C !important;
  }
  .bg-danger{
    background: #F56C6C !important;
  }
  .bg-info{
     background: #f1f5fa !important;
   }
  .color-primary{
    color: #0a1e39 !important;
  }
  .color-success{
    color: #67C23A !important;
  }
  .color-warning{
    color: #E6A23C !important;
  }
  .color-danger{
    color: #F56C6C !important;
  }
  .color-info{
    color: #909399 !important;
  }
  .color-text{
    color: #ffffff !important;
  }
  .color-main{
    color: #303133 !important;
  }
  .color-base{
    color: #606266 !important;
  }
  .color-show{
    color: #C0C4CC !important;
  }
  *::-webkit-scrollbar {
    width: 5px;
    height: 10px;
    border-radius: 5px;
  }
  *::-webkit-scrollbar-thumb{
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.15);
    background: rgba(0,0,0,0.15);
  }
  *::-webkit-scrollbar-track{
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.15);
    background: rgba(0,0,0,0.15);
  }
  .v2_need_panel {
    width: 100%;
    height: calc(100% - 20px);
    overflow-y: scroll;
  }

  .v2_need_panel::-webkit-scrollbar {
    display: none;
  }

  .v4-main .el-footer{
    width: 100%;
    height: 60px;
    position: absolute;
    display: flex;
    align-items: center;
    z-index: 1;
    left: 0;
    bottom: 0;
    background: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue